module.exports = __webpack_public_path__ + "static/img/7bg_6.510cf84.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_6.png
// module id = 752
// module chunks = 1